module.exports = new __parcel__URL__("fo_solo.c152f81f.svg").toString();